var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 92 92",
    enableBackground: "new 0 0 92 92",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1489_",
    d: "M60.9,25.5c3.2,3.6,4.7,8.5,4,13.7c-1.2,9.6-8.2,13-14.4,13c-0.3,0-0.5,0-0.5,0v2.4c0,2.2-1.8,4-4,4 s-4-1.8-4-4v-3.2c0-3.3,1.4-7.2,8.5-7.2c3.9,0,5.9-2,6.4-6c0.2-1.3,0.3-4.8-2.1-7.4c-1.9-2.1-5-3.2-9.2-3.2c-9,0-9.3,5.9-9.3,6.5 c0,2.2-1.8,4-4,4s-4-1.8-4-4c0-4,3.1-14.5,17.3-14.5C53.9,19.6,58.5,22.8,60.9,25.5z M45.7,62c-1.3,0-2.6,0.5-3.5,1.5 c-0.9,0.9-1.5,2.2-1.5,3.5c0,1.3,0.5,2.6,1.5,3.5c0.9,0.9,2.2,1.5,3.5,1.5c1.3,0,2.6-0.5,3.5-1.5c0.9-0.9,1.5-2.2,1.5-3.5 c0-1.3-0.5-2.6-1.5-3.5C48.3,62.6,47.1,62,45.7,62z M92,46c0,25.4-20.6,46-46,46S0,71.4,0,46S20.6,0,46,0S92,20.6,92,46z M84,46 C84,25,67,8,46,8S8,25,8,46s17,38,38,38S84,67,84,46z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question-icon.703f49f0131c7fab038bcd2327ddde1b.svg";
export { ForwardRef as ReactComponent };